/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/allas/components/standalone/Navigation/theme';

export const NavigationTheme = theme;
